module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAeUlEQVR42u3asQkAIAxFwb//bO4UN9BCECUXeAPkqhRJVaVzAQAAAAAAAAAAAAAAQLcBAAAAAAAAAFwGGMkyAAAAAAAAAMC/ALsFTwMAAAAAAAAAOIQAAAAAAAAAAP8BPDQAAAAAAAAAAI+SAAAAAAAAAAAAAAB0bAJk12yLHYubsgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Red-Cross.png
// module id = rx7G
// module chunks = 0 62 63